import React, {Fragment} from 'react';

import withClass from '../../../../hoc/withClass';
import Icon from '../../../UI/Icon/Icon';
import CalendarList from './CalendarList/CalendarList';
import FilterList from './FilterList/FilterList';

const aside = ({setFilter}) => {
    return (
        <Fragment>
            <div className="page-aside-switch">
                <Icon iconClass="icon md-chevron-left" />
                <Icon iconClass="icon md-chevron-right" />
            </div>
            <div className="page-aside-inner page-aside-scroll">
                <div data-role="container">
                    <div data-role="content">
                        <CalendarList />
                        <FilterList setFilter={setFilter}/>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default withClass(aside, 'page-aside');